import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import PreDoc from '@/components/correspondence/pre-doc';
import print from 'vue-print-nb';
var JsBarcode = require('jsbarcode');
import XLSX from 'xlsx';
import { renderAsync } from "docx-preview";
import { getEditorFileSrc } from "@/api/upload";
export default {
  name: "print-correspondence",
  directives: {
    print: print
  },
  components: {
    PreDoc: PreDoc
  },
  computed: {
    list: function list() {
      var _this = this;
      return this.printQueue.map(function (item) {
        var fileType = undefined;
        if (item.c02SendFile1) {
          fileType = item.c02SendFile1.split('.').pop();
        }
        return {
          html: item._content,
          code: _this.convertImageToCanvas(item),
          c02SendFile1: item.c02SendFile1,
          isDocx: fileType === 'docx',
          isExcel: fileType === 'xlsx' || fileType === 'xls',
          isImage: ['png', 'jpg', 'jpeg', 'bmp', 'webp'].includes(fileType),
          isPdf: fileType === 'pdf'
        };
      });
    }
  },
  methods: {
    getFileContent: function getFileContent(item, key, dom) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, file, image, src;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getEditorFileSrc({
                f: key
              });
            case 1:
              data = _context2.v;
              if (!item.isDocx) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return _this2.$awaitTo(renderAsync(data.data, document.documentElement.querySelector('.docContent' + dom), null, {
                inWrapper: false
              }));
            case 2:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              if (err) {
                console.log(err);
                _this2.$message.error('上传的word文档不能空白');
              }
              _context2.n = 4;
              break;
            case 3:
              if (item.isExcel) {
                file = new FileReader();
                file.onload = /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(result) {
                    var workbook, sheetNames, html;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          _context.n = 1;
                          return XLSX.read(this.result);
                        case 1:
                          workbook = _context.v;
                          sheetNames = workbook.SheetNames;
                          html = '';
                          sheetNames.forEach(function (name) {
                            var worksheet = workbook.Sheets[name];
                            if (Object.keys(worksheet).length > 1) {
                              html += XLSX.utils.sheet_to_html(worksheet);
                            }
                          });
                          document.documentElement.querySelector('.docContent' + dom).innerHTML = html;
                        case 2:
                          return _context.a(2);
                      }
                    }, _callee, this);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }();
                file.readAsArrayBuffer(data.data);
              } else if (item.isImage) {
                image = document.createElement('img');
                image.src = URL.createObjectURL(data.data);
                document.documentElement.querySelector('.docContent' + dom).append(image);
              } else if (item.isPdf) {
                src = URL.createObjectURL(data.data);
                window.open(src, "_blank");
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getPixelRatio: function getPixelRatio(context) {
      var backingStore = context.backingStorePixelRatio || context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
      return (window.devicePixelRatio || 1) / backingStore;
    },
    convertImageToCanvas: function convertImageToCanvas(item) {
      var canvas = document.createElement("canvas");
      var context = canvas.getContext('2d');
      var ratio = this.getPixelRatio(context);
      canvas.width = 180 * ratio;
      canvas.height = 60 * ratio;
      JsBarcode(canvas, "H".concat(item.c02ConfirmCode), {
        width: 3,
        //设置条之间的宽度
        height: 60,
        //高度
        fontSize: 15
      });
      return canvas.toDataURL("image/png");
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    submit: function submit() {
      var ignoreElements = this.list.map(function (item, index) {
        return "print-margin-".concat(index);
      });
    },
    updateBarcode: function updateBarcode() {
      var _this3 = this;
      this.printQueue.forEach(function (item, index) {
        var canvas = _this3.$refs["code-".concat(index)];
        JsBarcode(canvas, item.c02ConfirmCode, {
          width: 3,
          //设置条之间的宽度
          height: 60,
          //高度
          fontSize: 15
        });
      });
    }
  },
  data: function data() {
    return {
      printQueue: [],
      src: undefined,
      printObj: {
        // 打印配置对象
        id: 'print-correspondence',
        popTitle: '&nbsp;',
        extraHead: '<meta http-equiv="Content-Language" content="zh-cn"/>',
        extraCss: "./css/print-view.css"
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {
    // this.updateBarcode();
    var printQueue = window.sessionStorage.getItem('updatePrintQueue');
    if (printQueue) {
      this.printQueue = JSON.parse(printQueue);
    }
  }
};